<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useDialog } from 'primevue/usedialog';
import Button from 'primevue/button';
import TourNotesModal from '@/components/modal/tour/TourNotesModal.vue';

const props = defineProps<{
  data: any;
  groupTypeList: object[];
}>();

const { t } = useI18n({ useScope: 'global' });
const dialog = useDialog();

const openTourNotesModal = () => {
  dialog.open(TourNotesModal, {
    data: {
      data: props.data,
      groupTypeList: props.groupTypeList
    },
    props: {
      header: t('management.tour.list_tour_detail.notes'),
      modal: true,
      maximizable: true
    }
  });
};
</script>

<template>
  <Button :label="t('management.tour.list_tour_detail.notes')" class="p-button-outlined p-button-xs border-noround w-full mb-1" @click="openTourNotesModal()" />
</template>
